export default __webpack_public_path__ + "static/media/icon-website-conversion.17b73c37.svg";